module.exports = __webpack_public_path__ + "img/cb9-r-010.90c292f6.gif";